import { render, staticRenderFns } from "./TableBasicAnalisys.vue?vue&type=template&id=649f6dde&scoped=true&"
import script from "./TableBasicAnalisys.vue?vue&type=script&lang=js&"
export * from "./TableBasicAnalisys.vue?vue&type=script&lang=js&"
import style0 from "./TableBasicAnalisys.vue?vue&type=style&index=0&id=649f6dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f6dde",
  null
  
)

export default component.exports